import type { HomeView } from './HomeView';

/** Подання «Моєї роботи» в порядку меню. */
export const HOME_VIEWS: readonly HomeView[] = ['mine', 'week', 'overdue'];

/** Чи є рядок ключем подання (маршрут /work/:view). */
export const isHomeView = (value: string | undefined): value is HomeView => HOME_VIEWS.includes(value as HomeView);

/** Дата ISO (yyyy-mm-dd) через `days` днів від `today`. */
export function addDays(today: string, days: number): string {
  const d = new Date(`${today}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

/**
 * Чи належить відкритий запис, призначений мені, до подання (прототип v4 homeView): mine — усі; week — термін від сьогодні до +7 днів;
 * overdue — термін раніше за сьогодні. Те саме правило, за яким сервер рахує лічильники GET /me/work. Чиста функція.
 */
export function inHomeView(record: { due?: string | null }, view: HomeView, today: string): boolean {
  const due = (record.due ?? '').slice(0, 10);
  if (view === 'week') return !!due && due >= today && due <= addDays(today, 7);
  if (view === 'overdue') return !!due && due < today;
  return true;
}
